export default {
    statuses: {
        OPEN: 'NA ČEKANJU',
        OUT_OF_TIME: 'ZA ODLAGANJE',
        ACCEPTED: 'PRIHVAĆENA',
        DECLINED: 'ODBIJENA',
        CANCELED: 'OTKAZANA',
        DONE: 'ZAVRŠENA',
        DONE_BY_CRON: 'ZAVRŠENA',
        UNAVAILABLE: 'NEDOSTUPAN',
        NO_SHOW: 'NIJE SE POJAVIO',
    },
    actions: {
        ACCEPT: 'PRIHVATI',
        DECLINE: 'ODBIJ',
        CANCEL: 'OTKAŽI',
        RESCHEDULE: 'ODLOŽI',
        MAKE_UNAVAILABLE: 'POSTAVI NEDOSTUPNO',
        VIEW: 'PRIKAŽI',
        UNAVAILABLE: 'Otkaži i postavi termin nedostupnim',
        DONE: 'POJAVIO SE',
        FINISH: 'ZAVRŠI',
        NO_SHOW: 'NIJE SE POJAVIO',
        FINISH_EARLY: 'SKRAĆENJE REZERVACIJE',
        REMOVE_FINISH_EARLY: 'UKLONI SKRAĆENJE REZERVACIJE',
    },
    modal: {
        cancel_heading: 'Da li ste sigurni da želite da otkažete?',
        decline_or_make_unavailable: 'Da li ste sigurni da želite da odbijete termin?',
        cancel_or_make_unavailable: 'Da li ste sigurni da želite da otkažete termin?',
        no_show_headling: 'Da li se korisnik pojavio?',
        finish_early_heading: 'Završi ranije',
        finish_early_description:
            'Podesite vrijeme završetka ove rezervacije kako biste omogućili da naredne rezervacije počnu ranije. Odredite koliko minuta nakon početka događaja ćete biti dostupni za sledeću rezervaciju.',
        finish_early_chose: 'Izaberite vrijeme',
        remove_finish_early_modal: 'Da li ste sigurni da želite da uklonite ranije završeno vrijeme?',
    },
}
